// Translation of GrapesJS page content: only plain-text pieces are sent to
// the translate API, the component tree and styles are copied untouched.

const SKIP_TRANSLATE_TYPES = ['script', 'style', 'code', 'svg'];

const clone = (value) => JSON.parse(JSON.stringify(value));

// Walks GrapesJS component JSON and calls `visit(node, key)` for every
// translatable plain-text string (textnodes and tag-free `content`).
const walkTranslatableTexts = (components, visit) => {
  (components || []).forEach((node) => {
    if (!node || SKIP_TRANSLATE_TYPES.includes(node.type)) return;
    if (
      typeof node.content === 'string' &&
      node.content.trim() &&
      !/<[a-z!/]/i.test(node.content)
    ) {
      visit(node, 'content');
    }
    if (Array.isArray(node.components)) {
      walkTranslatableTexts(node.components, visit);
    }
  });
};

// Snapshot of the source editor + texts to send: { t0: '...', t1: '...' }
export const buildTranslationRequest = (editor) => {
  const components = clone(editor.getComponents());
  const styles = clone(editor.getStyle());

  const texts = {};
  let index = 0;
  walkTranslatableTexts(components, (node, field) => {
    texts[`t${index++}`] = node[field].trim();
  });

  return { components, styles, texts };
};

// Returns a copy of `components` with translated texts. Missing or empty
// translations keep the original text.
export const applyTranslations = (components, localeTexts = {}) => {
  const localized = clone(components);
  let index = 0;

  walkTranslatableTexts(localized, (node, field) => {
    const value = localeTexts[`t${index++}`];
    if (typeof value !== 'string' || !value.trim()) return;
    // Keep original surrounding whitespace so text next to inline
    // tags (<b>, <a>, ...) doesn't get glued together
    const original = node[field];
    const leading = original.match(/^\s*/)[0];
    const trailing = original.match(/\s*$/)[0];
    node[field] = `${leading}${value.trim()}${trailing}`;
  });

  return localized;
};

// Replaces target editor content with the translated copy of the source
export const applyTranslationToEditor = (editor, request, localeTexts) => {
  editor.setComponents(applyTranslations(request.components, localeTexts));
  editor.setStyle(request.styles);
};
